// extracted by mini-css-extract-plugin
export default {"plansContainer":"Dashboard_plansContainer__bEqeZ","content":"Dashboard_content__sSOmD","scrollIndicator":"Dashboard_scrollIndicator__6FzFo","bounce":"Dashboard_bounce__QsHv5"};